<div class="disclosure-group">
  <ng-content />
</div>
